import { render } from "./HowWirterCode.vue?vue&type=template&id=2b41fbb1&scoped=true"
import script from "./HowWirterCode.vue?vue&type=script&lang=js"
export * from "./HowWirterCode.vue?vue&type=script&lang=js"

import "./HowWirterCode.vue?vue&type=style&index=0&id=2b41fbb1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b41fbb1"]])

export default __exports__